<template>
  <v-dialog v-model="show" persistent max-width="500px">
    <v-card class="dialog-container">
      <v-container>
        <v-card-title primary-title>
          <span class="dialog-title">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <div>{{ content }}</div>
        </v-card-text>
      </v-container>
      <v-card-actions>
        <v-spacer />
        <main-button
          :text="adminText('shellAll.cancel', 'Cancel')"
          style="margin-right: 12px"
          flat
          outline
          :disabled="actionPending"
          @click="closeDialog()"
        />
        <main-button
          :text="actionMessage || adminText(&quot;shellAll.delete&quot;, &quot;Delete&quot;)"
          color="error"
          :loading="actionPending"
          @click="confirmDelete"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import AdminContext from '@/admin-i18n/context'
export default {
  mixins: [AdminContext],
  name: 'delete-dialog',
  props: {
    show: Boolean,
    title: String,
    content: String,
    onDelete: Function,
    actionMessage: String,
    waitForCompletion: { type: Boolean, default: false },
  },
  data() {
    return { actionPending: false }
  },
  methods: {
    async confirmDelete() {
      if (this.actionPending) return
      if (!this.waitForCompletion) {
        this.onDelete()
        this.closeDialog()

        return
      }
      this.actionPending = true
      try {
        const result = await this.onDelete()
        if (result !== false) this.closeDialog()
      } finally {
        this.actionPending = false
      }
    },
    closeDialog() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style scoped>
.dialog-container {
  padding-bottom: 1.5rem !important;
  padding-right: 1.5rem !important;
}
</style>
